import React from 'react'
import { analytics } from '@helpers/analytics'
import Colors from '../Colors'
import styles from './styles.module.scss'
import { ProductWithVariants } from 'types/product'

type TabProps = {
  active: boolean
  tabName: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
}
const Tab = ({ active, tabName, onClick }: TabProps) => (
  <button
    type="button"
    className={`${styles.Tabs__tab} ${active ? styles.active : ''}`}
    onClick={onClick}
  >
    {tabName}
  </button>
)

type TabContentProps = {
  showTab: boolean
  renderColors: React.ReactNode
  colorInfo: React.ReactNode
}
const TabContent = ({ colorInfo, renderColors, showTab }: TabContentProps) => (
  <div
    className={styles.Tabs__content}
    data-content="cotton"
    data-hidden={!showTab}
  >
    <Colors>{renderColors}</Colors>
    {colorInfo}
  </div>
)

type TabItem = {
  color_categories: string[]
  tab_title: string
  product_type: string
  products: ProductWithVariants[]
}
type TabsProps = {
  tabs: TabItem[]
  handleTabSwitch: (products: TabItem['products']) => void
  activeTab: string
  renderColors: (tab: TabItem) => React.ReactNode
  colorInfo: React.ReactNode
}

function Tabs({
  tabs,
  activeTab,
  handleTabSwitch,
  colorInfo,
  renderColors
}: TabsProps) {
  const handleTabClick = (tab: TabItem) => {
    analytics('Click', {
      category: 'Product Page',
      label: `Product tab (${tab.tab_title})`,
      product_type: tab.product_type
    })
    handleTabSwitch(tab.products)
  }

  return (
    <section>
      <div id="product-tabs" className={styles.Tabs__nav}>
        {tabs.map(tab => {
          return (
            <Tab
              key={tab.tab_title}
              tabName={tab.tab_title}
              active={activeTab === tab.tab_title}
              onClick={() => handleTabClick(tab)}
            />
          )
        })}
      </div>
      <div className="grid__container">
        {tabs.map(tab => {
          return (
            <TabContent
              key={tab.tab_title}
              showTab={activeTab === tab.tab_title}
              colorInfo={colorInfo}
              renderColors={renderColors(tab)}
            />
          )
        })}
      </div>
    </section>
  )
}

export default Tabs
